import AUX from "../../../hoc/Aux_";
import React, { Component } from "react";
import { MDBInput } from "mdbreact";
import { connect } from "react-redux";
import mailGunEmailActions from "../../../store/mailgunEmails/action";
import arrayMove from "array-move";
import $ from "jquery";
import _ from "lodash";
import axios from "../../Shared/auth-header";
import { toast } from "react-toastify";
import AuthService from "../../Auth/AuthService";

import { Modal } from "react-bootstrap";
import SavedSearchEmailList from "./SavedSearchEmailList";
import SortableComponent from "./SortableComponent";
import ConfirmationModal from "./ConfirmationModal";
import SavedSearchCustomizer from "./SavedSearchCustomizer";
import * as Permissions from "../../Permissions/PermissionValues";
import AssignMember from "./AssignMemberModal";
import MailGunEmailTypes from "../../Email/Enums/MailGunEmailTypes";
import EmailConfigTabs from "../../Email/Enums/EmailConfigTabs";

class EditSavedSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: "",
      memberSearchText: "",
      memberSearchText_err: "",
      valid: false,
      redirectToNewPage: false,
      addMember: {
        MemberType: "",
        AssignmentTypeId: 1,
        MemberId: 0,
        PositionId: 0,
      },
      memberMethods: this.props.memberMethods,

      membersMethods: this.props.membersMethods,
      memberName: this.props.memberName,
      isLookup: this.props.isLookup || false,
      page: 1,
      facility: this.props.facility ? this.props.facility : "",
      data: [],
      sizePerPage: 25,
      totalCount: 0,
      keyword: "",
      SortOrder: "seniorityasc",
      isAdvanceSearch: false,
      delId: 0,
      filters: [],
      showActive: true,
      memberId: AuthService.getProfile().memberData.id,
      items: [],
      resultData: [],
      initialItems: [],
      itemIndexes: [],
      itemColumnIds: [],
      replacingMemberId: 0,
      replacingMemberName: "",
      searchId: 0,
      searchTypeId: 0,
      showModal: this.props.showModal,
      _dataArray: [],
      isOpen: false,
      SearchName: "",
      openEmailListDialog: false,
      dialogContentClass: "",
      availableFields: [],
      categoryFields: [],
      selectedFields: [],
      sortItems: [],
      items: [],
      deletedItems: [],
      index: "",
      UserFirstName: "",
      UserLirstName: "",
      showCustomModal: false,
      showAssignMemberModal: false,
      prevent: false,
      emailListId: 0,
      entityKey: 0,
    };

    this.handleEvent = this.handleEvent.bind(this);

    this.membersMethods = () => {
      let array = [];

      this.setMember = (args) => {
        array.push(args);

        if (this.state._dataArray != null) {
          this.setState({ _dataArray: this.state._dataArray.concat(array) });
        } else {
          this.setState({ _dataArray: array });
        }
      };
      return this;
    };

    this.changeState = () => {
      this.setState({ isOpen: false });
    };

    this.confirm = () => {
      this.confirmed = () => {
        if (this.state.index !== -1) {
          let delMemberID = this.state._dataArray.splice(this.state.index, 1);
          let values = this.state._dataArray.filter(
            (e, i) => i !== this.state.index
          );
          this.setState({ _dataArray: values });

          const url = `/api/SavedSearch/DeleteSharedSearch/`;
          const body = {
            saved_search_id: this.state.searchId,
            member_id: delMemberID[0].id,
            is_pinned: this.state.is_pinned,
          };
          axios.post(url, body).then(({ data }) => {
            if (data.status.toLowerCase() === "success") {
              //toast.success(data.message);
            } else {
              //toast.error(data.message);
            }
          });
        }
        this.toggleConfirm();
      };
      return this;
    };
  }

  forceSearchRefresh = (forceRefresh) => {
    if (forceRefresh === true) {
      const body = {
        SearchId: this.state.searchId,
        MemberId: AuthService.getProfile().memberData.id,
        SearchType: this.state.searchTypeId,
      };

      this.showSpinner();
      axios
        .post("/api/SavedSearch/GetSavedSearchFilter", body)
        .then(({ data: response }) => {
          this.hideSpinner();
          if (response.status) {
            if (response.status.toLowerCase() === "success") {
              this.props.setSavedSearchCriteria({
                savedSearchCriteriaDetail: response,
                searchTypeId: this.state.searchTypeId,
                searchId: this.state.searchId,
              });
              this.getDefaultColumns(
                this.state.searchId,
                this.state.searchTypeId
              );
            } else {
              toast.error(response.message);
            }
          } else {
            toast.error("Could not retrieve saved search detail.");
          }
        });
    }
  };

  customizeSearchDialogClosed = (requiresRefresh) => {
    this.setState({
      showCustomModal: false,
    });
  };

  toggleConfirm = () => {
    this.setState({
      isConfirmModalOpen: !this.state.isConfirmModalOpen,
    });
  };

  assignMemberListClosed = () => {
    this.setState({
      showAssignMemberModal: false,
    });
  };

  SearchCustomizer = () => {
    this.setState({ showCustomizeModal: true });
  };

  setIndex = (user, index) => {
    this.setState({
      index: index,
      UserFirstName: user.firstName,
      UserLastName: user.lastName,
    });
  };

  getDefaultColumns(searchId, searchType) {
    if (
      isNaN(searchId) ||
      searchId == null ||
      isNaN(searchType) ||
      searchType == null
    ) {
      return;
    }

    this.setState({
      searchId: searchId,
      searchTypeId: searchType,
      //showModal: true
    });

    const url = `/api/SavedSearch/GetColumns/`;

    const body = {
      SearchId: searchId,
      MemberId: this.state.memberId,
      SearchType: searchType,
    };
    axios.post(url, body).then(({ data }) => {
      var tempArr = [];
      this.setState({
        resultData: data.searchColumns,
        _dataArray: data.membersList,
      });

      //tempArr.push(data.searchColumns);
      // for (let i = 0; i < data.searchColumns.length; i++)
      //   tempArr.push(data.searchColumns[i]);
      this.setState({
        items: tempArr,
        initialItems: tempArr,
        selectedFields: [...data.searchColumns],
      });
    });
  }

  showSearchColumns = () => {
    this.setState({
      availableFields: [],
      selectedFields: [],
      categoryFields: [],
    });
    this.showSpinner();
    let url = `/api/SavedSearchColCategory/GetColumnCatgories?savedSearchId=${this.props.savedSearchId}&memberId=${this.state.memberId}`;
    let { selectedFields } = this.state.selectedFields;
    if (this.state.savedSearchId > 0) {
      selectedFields = [];
    }
    axios.post(url, selectedFields).then(({ data: response }) => {
      this.setState({
        availableFields: response.availableFields,
        selectedFields: response.selectedFields,
        savedSearchId: this.props.savedSearchId,
        selectedFieldsCount: response.selectedFields.length,
      });
      let fields = [];
      response.availableFields.map((category) => {
        fields = [...fields, ...category.savedSearchColumns];
      });
      this.setState({
        categoryFields: [...fields],
      });

      this.renderAvailableFields();
      this.hideSpinner();
    });
  };

  SaveACopy() {
    this.showSpinner();
    axios
      .post(`/api/SavedSearch/CopySavedResults?Id=${this.state.searchId}`)
      .then(({ data: response }) => {
        if (response.status === "success") {
          toast.success(response.message);
          this.setState({
            requiresResultRefresh: true,
          });
          //this.forceSearchRefresh(this.state.requiresResultRefresh);
          this.props.setSavedSearchCriteria(null);
          this.props.updateAndSelect(response.id, true);
          this.handleClose();
        } else {
          toast.error(response.message);
        }
        this.hideSpinner();
      });
  }

  mapFieldsWithSearch() {
    this.showSpinner();
    const body = this.state.selectedFields;
    let { selectedFields } = this.state;
    selectedFields = JSON.parse(JSON.stringify(body));
    // this.state.SearchName
    axios
      .post(
        `/api/SavedSearch/MapcolumnsWithSearch?savedSearchId=${this.state.searchId}&memberId=${this.state.memberId}&searchName=${this.state.SearchName}`,
        body
      )
      .then(({ data: response }) => {
        if (response.status === "success") {
          // toast.success("Field(s) successfully mapped with search.");
          this.setState({
            requiresResultRefresh: true,
            SearchName: "",
          });
          if (this.state._dataArray != null) {
            const body = this.state._dataArray;
            axios
              .post(
                `/api/SavedSearch/SaveSharedSearch?searchId=${this.state.searchId}`,
                body
              )
              .then(({ data: response }) => {
                if (response.status === "success") {
                  let message = "Search details saved successfully.";
                  if (this.state.searchTypeId) {
                    if (this.state.searchTypeId == 1) {
                      message = "Saved search saved successfully.";
                    } else if (this.state.searchTypeId == 2) {
                      message = "Bucket search saved successfully.";
                    }
                  }
                  toast.success(message);
                  this.setState({
                    requiresResultRefresh: true,
                  });
                  this.handleClose();
                } else {
                  toast.error(response.message);
                }
                this.hideSpinner();
              });
          }
          this.handleClose();
          this.setState({ prevent: true });

          this.props.setSavedSearchCriteria(null);
          this.props.updateAndSelect(this.state.searchId, true);

          //   this.forceSearchRefresh(this.state.requiresResultRefresh);
        } else {
          toast.error(response.message);
        }
        this.hideSpinner();
      });
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ items }) => ({
      items: arrayMove(items, oldIndex, newIndex),
    }));
  };

  onSortStart = ({ node, index, collection, isKeySorting }, event) => {
    $(".sortable-item-list").addClass("sorting");
    $(node).addClass("active-sort-item");
  };

  searchTextChangeHandler = (event) => {
    console.log({ [event.target.name]: event.target.value });

    this.setState({ [event.target.name]: event.target.value });

    var inputValue = event.target.value.trim();
    if (inputValue !== "") {
      if (
        inputValue.indexOf(" ") > 0 &&
        !(
          /^[a-zA-Z]*$/.test(inputValue.split(" ")[0]) &&
          /^[a-zA-Z]*$/.test(inputValue.split(" ")[1])
        )
      ) {
        $(".MemberSearchField").addClass("inputBorderRed");
        this.setState({
          [event.target.name + "_err"]: "Name should contain alphabets only.",
        });
        this.setState({ valid: false });
      } else if (
        !(/^[a-zA-Z ]*$/.test(inputValue) || /^[0-9]*$/.test(inputValue))
      ) {
        /// alphanumeric or special characers with one word
        $(".MemberSearchField").addClass("inputBorderRed");
        this.setState({
          [event.target.name + "_err"]: "Alphanumeric is not allowed.",
        });
        this.setState({ valid: false });
      } else {
        $(".MemberSearchField").removeClass("inputBorderRed");
        this.setState({ [event.target.name + "_err"]: "" });
        this.setState({ valid: true });
      }
    } else {
      this.setState({ valid: false });
      this.setState({ [event.target.name + "_err"]: "" });
      $(".MemberSearchField").removeClass("inputBorderRed");
    }
  };

  handleEvent() {
    this.getMembers(this.state.memberSearchText, "");
  }

  getMembers(key, facility) {
    const url = `/api/member/SearchMembers`;
    const formData = {
      Keyword: key,
      Facility: facility,
      PageNo: 1,
      PageSize: 10,
      ShowOnlyActive: true,
    };
    axios.post(url, formData).then(({ data }) => {
      if (data.status && data.status.toLowerCase() == "success") {
        this.setState({
          data: data.data,
          totalCount: data.totalCount,

          isOpen: true,
        });

        if (!_.isEmpty(key)) {
          $("#keyword").val(key);
        }

        $(".loading").hide();
        //this.props.setFacilityMembersLoading(false)
      } else {
        $(".loading").hide();
        // this.props.setFacilityMembersLoading(false)
        toast.error(data.message);
      }
    });
  }

  editSearchItem(id, searchType, searchName) {
    this.showSpinner();
    this.getDefaultColumns(id, searchType);
    this.setState({ SearchName: searchName });
    this.hideSpinner();
  }

  handleClose = () => {
    this.props.onClose();
    this.setState({
      showModal: false,
    });

    console.log(this.state.prevent);
  };

  showSpinner = () => {
    $(".loading").show();
  };

  hideSpinner = () => {
    $(".loading").hide();
  };

  showEmailListDialog = async () => {
    this.setState({
      openEmailListDialog: true,
      dialogContentClass: "transparent",
    });
    //Add Mode
    if (this.state.emailListId == 0) {
      await this.props.setCurrentEmailConfigTab(EmailConfigTabs.Settings);
    }
  };
  closeEmailListDialog = () => {
    this.setState({
      openEmailListDialog: false,
      dialogContentClass: "",
    });
  };

  onShow = async () => {
    $(".loading").show();
    if (this.state.searchId <= 0) return;
    if (this.state.searchId <= 0) return;
    const url = `/api/SavedSearch/GetEmailListDetail?savedSearchId=${this.state.searchId}`;
    await axios.get(url).then(async ({ data: response }) => {
      await this.setState({
        emailListId: response.id,
        entityKey: response.saved_search_id,
        //mailingListName: data.email_list_title,
      });
      ///////// Work of Email Enhancements/////////

      if (response.id == 0) {
        // means no email list exists
        await this.props.resetEmailConfigDetails();
      } else {
        let formData = {
          emailListId: response.id,
          emailEntityType: MailGunEmailTypes.Member,
          entityKey: response.saved_search_id,
        };
        // formData.emailListId &&
        //   formData.emailEntityType &&
        //   this.props.getAuthSenders(formData);
        await this.props.setEmailListDetails(formData);
        await this.props.setMgListFullAddress(response.email_address);
      }
      ////////////////////////////////////////////
    });
    $(".loading").hide();
  };

  removeSelectedField = (fieldId) => {
    let selectedFields = [...this.state.selectedFields];
    let filteredItem = selectedFields.filter((fld) => {
      return fld.id === fieldId;
    });
    let fieldToRemove = filteredItem[0];
    const index = selectedFields.indexOf(fieldToRemove);
    if (index > -1) {
      selectedFields.splice(index, 1);
    }
    this.setState({
      items: selectedFields,
      selectedFields: selectedFields,
    });
  };

  selectedFieldSorted = (oldIndex, newIndex) => {
    let sortedFields = arrayMove(
      [...this.state.selectedFields],
      oldIndex,
      newIndex
    );
    let items = arrayMove([...this.state.items], oldIndex, newIndex);
    this.setState({
      selectedFields: sortedFields,
      items: items,
    });
  };

  canCreateEmailList = () => {
    var result = AuthService.canAdd(Permissions.Email_Lists);
    return result;
  };

  canUpdateEmailList = () => {
    var result =
      AuthService.canUpdate(Permissions.Email_Lists) ||
      AuthService.canView(Permissions.Email_Lists);
    return result;
  };

  canCreateOrUpdatEmailList = () => {
    if (this.state.emailListId <= 0) {
      return this.canCreateEmailList();
    } else {
      return this.canUpdateEmailList();
    }
  };

  emailListSaved = (listId, entityKey) => {
    if (listId) {
      if (this.state.emailListId <= 0) {
        this.setState({
          emailListId: listId,
          entityKey: entityKey,
        });
      }
    }
  };
  emailListDeleted = () => {
    this.props.resetEmailConfigDetails();
    this.setState({ emailListId: 0 });
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value.replace(/[^\w\s]/gi, ""),
    });
  };

  render() {
    const { items } = this.state;
    var props = {
      items: [...this.state.selectedFields],
      dataKeyField: "id",
      textField: "column_name",
      showDeleteIcon: true,
      onItemDelete: this.removeSelectedField,
      showModal: this.props.showModal,
    };
    return (
      <AUX>
        {/* /// Configure Email for Mailgun from SaveSearch /////*/}

        <SavedSearchEmailList
          showModal={this.state.openEmailListDialog}
          onClose={this.closeEmailListDialog}
          savedSearchId={this.state.searchId}
          savedSearchType={this.state.searchTypeId}
          savedSearchTitle={this.state.SearchName}
          recordsPerPage={25}
          emailListId={this.state.emailListId}
          entityKey={this.state.entityKey}
          onSave={this.emailListSaved}
          onDeleteEmailList={this.emailListDeleted}
        ></SavedSearchEmailList>
        {/* /// Configure Email for Mailgun from SaveSearch /////*/}
        <Modal
          // className={`ShareModal ${this.state.dialogContentClass}`}
          show={props.showModal}
          onHide={this.handleClose}
          size="xl"
          backdrop="static"
          centered
          onShow={this.onShow}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h5 className="modal-title mt-0">UPDATE SAVED SEARCH</h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="some-class">
            <div className="col-12">
              <div className="row">
                <div className="col-md-7 col-sm-6">
                  <div className="md-form form-group">
                    <MDBInput
                      name="SearchName"
                      id="Name"
                      onChange={this.handleChange}
                      label="Name"
                      group
                      type="text"
                      required
                      width="50%"
                      value={this.state.SearchName}
                      disabled={this.state.emailListId <= 0 ? false : true}
                    >
                      <div className="invalid-feedback">Code is required.</div>
                    </MDBInput>
                  </div>
                </div>
                <div className="col-md-5 col-sm-6">
                  <div className="md-form form-group">
                    {this.canCreateOrUpdatEmailList() === true && (
                      <button
                        className="btn btn-success w-md waves-effect float-right  waves-light mr-2"
                        onClick={this.showEmailListDialog}
                      >
                        {this.state.emailListId <= 0
                          ? "Create Email List"
                          : "Update Email List"}
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div>
                <h4 className="card-subtitle mb-2 text-muted">
                  Customize Result{" "}
                  <SavedSearchCustomizer
                    savedSearchId={this.state.searchId}
                    searchTitle={""}
                    searchType={this.state.searchTypeId}
                    forceSearchRefresh={this.forceSearchRefresh.bind(this)}
                    pencilClass="pencil"
                  ></SavedSearchCustomizer>
                </h4>
              </div>
              <div className="sortable-items">
                {
                  <SortableComponent
                    {...props}
                    onSortEnd={(oldIndex, newIndex) =>
                      this.selectedFieldSorted(oldIndex, newIndex)
                    }
                  ></SortableComponent>
                }
              </div>

              <div>
                <h4 className="card-subtitle mb-2 mt-2 text-muted">
                  {" "}
                  Share This Search{"    "}
                  <span
                    onClick={() => {
                      this.setState({ showAssignMemberModal: true });
                    }}
                    className="fas fa-user"
                  ></span>
                </h4>
                <small>
                  Below is a list of all users who can access this saved searc.
                  Sharing this search with another user allows them to view the
                  BUEs resulting from the search, they will not be able to view
                  member details unless their permissions allow. The results
                  will be displayed with the filter criteria and results grid
                  you see when viewing the search.
                </small>

                {/*
                  <div className="input-group width100 mt-4">
                    <input
                      name="memberSearchText"
                      type="text"
                      id="memberSearchkeyword"
                      value={this.state.memberSearchText}
                      onChange={this.searchTextChangeHandler}
                      className="form-control MemberSearchField"
                      placeholder="Member Search .."
                    />
                    {
                      <div className="input-group-append">
                        <button
                          className="btn btn-outline-secondary"
                          type="button"
                          data-toggle="modal"
                          data-target=".members-modal-all"
                          onClick={this.handleEvent}
                        >
                          <i className="fa fa-search" />
                        </button>
                      </div>
                    }

                    <small className="text-danger w-100">
                      {this.state.memberSearchText_err}
                    </small>
                  </div>
                  */}

                <div className="mt-2">
                  <table className="table table-hover table-bordered">
                    <thead>
                      <tr>
                        <td>First Name</td>
                        <td>Last Name</td>
                        <td>Facility</td>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state._dataArray &&
                        this.state._dataArray.map((user, index) => (
                          <tr key={user.id}>
                            <td>{user.firstName}</td>
                            <td>{user.lastName}</td>
                            <td>
                              {user.facility}
                              <i
                                className="fas fa-trash-alt"
                                style={{ "margin-left": "60%" }}
                                onClick={() => {
                                  this.toggleConfirm();
                                  this.setIndex(user, index);
                                }}
                              ></i>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                <br />

                <div className="col-12 text-center mb-50 mt-50 pt-4">
                  <button
                    className="btn btn-danger w-md waves-effect cancelModal waves-light mr-2 mc"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onClick={this.handleClose}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-success w-md mc"
                    //onClick={() => this.onSaveSearch()}
                    onClick={this.mapFieldsWithSearch.bind(this)}
                  >
                    Save
                  </button>

                  <button
                    className="btn btn-primary ml-2 w-md mc"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onClick={this.SaveACopy.bind(this)}
                  >
                    Save A Copy
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/*this.state.isOpen == true ? (
          <MembersModalAll
            data={this.state.data}
            triggerState={this.changeState}
            membersMethods={this.membersMethods}
          />
        ) : null */}

        <ConfirmationModal
          confirm={this.confirm}
          modal={this.state.isConfirmModalOpen}
          toggle={this.toggleConfirm}
          UserFirstName={this.state.UserFirstName}
          UserLastName={this.state.UserLastName}
        />
        <AssignMember
          showModal={this.state.showAssignMemberModal}
          onClose={this.assignMemberListClosed}
          membersMethods={this.membersMethods}
        ></AssignMember>
      </AUX>
    );
  }
}

///export default EditSavedSearch;
export default connect(
  (state) => ({
    melstate: state.mailGunEmail,
  }),
  {
    ...mailGunEmailActions,
  },
  null,
  { forwardRef: true }
)(EditSavedSearch);
